import { Navigate } from "react-router-dom";

// Groups are now created from a sheet on the groups page; keep the old address working.
function AddCustomerGroup() {
  return <Navigate to="/dashboard/profile/customerGroup?create=1" replace />;
}

export default AddCustomerGroup;
